import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFieldAccessPins, pinsMatch } from "../utils/fieldAccessConfig";
import Dispatch from "./app/Dispatch";

export default function DispatchLoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
  const session = sessionStorage.getItem("fieldAccessDispatch");

  if (session === "true") {
    sessionStorage.setItem("fieldAccessStatusBoard", "true");
    sessionStorage.setItem("fieldAccessSource", "dispatch");
    setUnlocked(true);
  }

  setLoading(false);
}, []);

  async function handleLogin() {
    setError("");

    const config = await getFieldAccessPins();

    if (!pinsMatch(pin, config.dispatchPin)) {
      setError("Invalid PIN");
      return;
    }

    sessionStorage.setItem("fieldAccessDispatch", "true");
    sessionStorage.setItem("fieldAccessHQ", "true");
    sessionStorage.setItem("fieldAccessStatusBoard", "true");

    if (sessionStorage.getItem("fieldAccessSource") !== "command") {
      sessionStorage.setItem("fieldAccessSource", "dispatch");
    }

    setUnlocked(true);
  }

  function handleLock() {
    sessionStorage.removeItem("fieldAccessDispatch");

    if (sessionStorage.getItem("fieldAccessSource") === "dispatch") {
      sessionStorage.removeItem("fieldAccessHQ");
      sessionStorage.removeItem("fieldAccessStatusBoard");
      sessionStorage.removeItem("fieldAccessSource");
    }

    setUnlocked(false);
    setPin("");
  }

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;

  if (!unlocked) {
    return (
      <div style={styles.center}>
        <div style={styles.card}>
          <button onClick={() => navigate("/field-access")} style={styles.backBtn}>
            ← Back
          </button>

          <h2>Dispatch Access</h2>

          <input
            type="password"
            placeholder="Enter PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            style={styles.input}
          />

          <button onClick={handleLogin} style={styles.button}>
            Enter
          </button>

          {!!error && <div style={styles.error}>{error}</div>}
        </div>
      </div>
    );
  }

  return (
  <div style={{ height: "100vh", overflow: "hidden" }}>
    <Dispatch onLock={handleLock} />
  </div>
);
}

const styles = {
  center: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8fafc",
  },
  card: {
    background: "#fff",
    padding: 24,
    borderRadius: 12,
    width: 320,
  },
  input: {
    width: "100%",
    padding: 12,
    marginBottom: 12,
  },
  button: {
    width: "100%",
    padding: 12,
    background: "#0f766e",
    color: "#fff",
    border: "none",
    borderRadius: 8,
  },
  error: {
    color: "red",
    marginTop: 10,
  },
  header: {
    background: "#0f172a",
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
  },
  backBtn: {
    background: "transparent",
    border: "1px solid #cbd5e1",
    padding: "6px 10px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 700,
    marginBottom: 10,
  },
  lockBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 6,
  },
};